module.exports = __webpack_public_path__ + "img/menu-off_02.3e5140e0.png";